/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { clubMembershipPauseResumeInput } from '../../../dataActions/DataActionExtension.g';
import { IrsmClubMembershipPauseResumeResponse } from '../../../dataActions/DataServiceEntities.g';

/**
 * GetMembership Input Action
 */
export class MembershipStateInput implements Msdyn365.IActionInput {
    public input: IDataServiceRequest;
    constructor(input: IDataServiceRequest) {
        this.input = input;
    }

    public shouldCacheOutput = () => false;

    public getCacheKey = () => `IPauseMembershipInput`;
    public getCacheObjectType = () => 'IPauseMembershipInput';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IMembershipStateInput extends IrsmClubMembershipPauseResumeResponse { }

export interface IInputRequirements {
    wineClubId: string;
    pauseResume: boolean;
}

export const createMembershipStateInput = (
    args: Msdyn365.ICreateActionContext,
    { pauseResume, wineClubId }: IInputRequirements,
): MembershipStateInput => {
    const accNumber = args.requestContext.user.customerAccountNumber;
    return new MembershipStateInput(
        clubMembershipPauseResumeInput(
            accNumber!,
            wineClubId,
            pauseResume
        )
    );
};

export async function getMembershipStateAction(
    input: MembershipStateInput,
    ctx: Msdyn365.IActionContext,
): Promise<IMembershipStateInput> {
    return input.input.execute(ctx);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IMembershipStateInput>>getMembershipStateAction,
    input: createMembershipStateInput,
});